import React from "react";
import styles from "./Navbar.module.css";
import logo2 from "../../assets/logo/logo2.png";
import { Link } from "react-router-dom"

const Navbar = () => {
	return (
		<nav className={styles.navbar}>
			<div className={styles.logo}>
				<Link to="/inicio">
				<img src={logo2} alt='logo' />
				</Link>
			</div>
		</nav>
	);
};

export default Navbar;